import { useQuery } from "react-query";
import middlewareAPI from "../services/middleware";

const useGetProperty = (blossorId: any) => {
  const { isFetching, isFetched, data, error, refetch } = useQuery(
    ["getProperty", blossorId],
    async () => {
      const { data } = await middlewareAPI.get(
        `/listings/getPropertyByBlossorId/${blossorId}`
      );
      return data?.listings[0];
    },

    {
      staleTime: 300000,
      cacheTime: 300000,
      enabled: !!blossorId,
    }
  );
  return {
    isFetching,
    isFetched,
    data,
    error,
    refetch,
  };
};

export default useGetProperty;
